export default __webpack_public_path__ + "static/jmsm_preview-451dc43ecd3d26f0aaef9f9adabe3e9c.mp4";